"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentWidth = exports.calculateColumns = void 0;
var text_1 = require("utils/text");
var list_1 = require("types/list");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var calculateColumns = function (columns, keys, column) {
    var mapReduce = function (listColumnMap, key) {
        var col = listColumnMap[key];
        if (col) {
            switch (col.type) {
                case list_1.ListColumnType.text: {
                    var text = (0, utils_1.mapLocalization)(column[key]);
                    var len = (0, text_1.calculateStringLength)(text) + constants_1.ITEM_GAP;
                    col.pixelWidth = Math.max(col.pixelWidth, len);
                }
            }
        }
        return listColumnMap;
    };
    return keys.reduce(mapReduce, columns);
};
exports.calculateColumns = calculateColumns;
var getContentWidth = function (cols) {
    var mapReduce = function (total, col) {
        return total + col.pixelWidth;
    };
    return (Object.values(cols).reduce(mapReduce, 0) +
        constants_1.LIST_PADDING);
};
exports.getContentWidth = getContentWidth;
